import { PageComponent } from '@root/pages/Type';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { MethodRecordItem } from '../Types';
import styles from './Macro.module.scss';

type MethodProps = {
    amountValue: any;
    currentMethod: number;
    method: MethodRecordItem;
    onChooseMethod: (value: number) => void;
};

const Method: PageComponent<MethodProps> = (props) => {
    const { amountValue, method, currentMethod, onChooseMethod } = props;
    const { t } = useTranslation('uiPaymentsTopup');
    let title = '';
    let subtitle = '';
    if (method.translate && method.translate.indexOf(' ') > -1) {
        title = method.translate.substr(0, method.translate.lastIndexOf(' '));
        subtitle = method.translate.substr(method.translate.lastIndexOf(' '));
    } else {
        subtitle = method.translate;
    }
    let isDisabledMethod = false;
    let extraData = '';
    if (parseFloat(amountValue || 0) > 0 && method.min !== null && parseFloat(amountValue || 0) < method.min) {
        extraData = t('macro.amountToLow', {
            defaultValue: 'Suma per maza!',
        });
        isDisabledMethod = true;
    } else if (
        parseFloat(amountValue || 0) > 0 &&
        method.max !== null &&
        parseFloat(amountValue || 0) > method.max
    ) {
        extraData = t('macro.amountToBig', {
            defaultValue: 'Suma per didele!',
        });
        isDisabledMethod = true;
    } else if (method.fee !== null && parseFloat(amountValue || 0) > 0) {
        function parseFee(str) {
            return Function(`'use strict'; return (${str})`)();
        }
        extraData = `${t('macro.fee', {
            defaultValue: 'Administravimo mokestis',
        })}: ${parseFloat(
            parseFee(
                method.fee.replace(
                    '%amount%',
                    parseFloat(amountValue || 0).toFixed(2),
                ),
            ),
        ).toFixed(2)} €`;
    }
    return (
        <div
            className={classNames(`col-sm-6 col-md-4`, {
                [styles.active]: currentMethod === method.value,
            })}
            onClick={(e) => {
                e.preventDefault();
                if (isDisabledMethod) return;
                onChooseMethod(method.value);
            }}
        >
            <div
                className={classNames(styles.chooser_inner, {
                    [styles.image_only]: method && method.img,
                    [styles.with_sub]: !method.img,
                    [styles.disabled]: isDisabledMethod,
                })}
            >
                {method.img && (
                    <img
                        src={`/static/img/payments/${method.img}.png`}
                        alt={method.img}
                    />
                )}
                {!method.img && (
                    <>
                        <h5>{title}</h5>
                        <h4>{subtitle}</h4>
                    </>
                )}
                {extraData && (
                    <span className={styles.extra_text}>{extraData}</span>
                )}
            </div>
        </div>
    );
};

export default Method;
